import { SvgIconType } from './svg.interface';

const ArrowBack: SvgIconType = ({ width = 7, height = 12, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25611 2.05654L2.06262 6.25002L6.25611 10.4435C6.54927 10.7367 6.54927 11.212 6.25611 11.5052C5.96294 11.7983 5.48763 11.7983 5.19447 11.5052L0.46967 6.78035C0.176777 6.48746 0.176777 6.01259 0.46967 5.7197L5.19447 0.994898C5.48763 0.701733 5.96294 0.701733 6.25611 0.994898C6.54927 1.28806 6.54927 1.76338 6.25611 2.05654Z"
      fill="#4F566B"
    />
  </svg>
);

export default ArrowBack;
